import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";
import { useInvalidateWorkflowListQuery } from "./use-workflows-query";

export default function useDeleteWorkflow(shopId: string) {
	return useApiMutation(
		"delete",
		"/shops/{shopId}/workflows/{workflowId}",
		{
			invalidate: [
				useInvalidateShop(shopId),
				useInvalidateWorkflowListQuery(shopId),
			],
			mapVariables: (workflowId: string) => ({
				params: { path: { shopId, workflowId } },
			}),
		},
	);
}
